import * as React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { getAssessmentTabsIndicatorStyle } from "../../components/customstyles/AssessmentTabsIndicatorStyle";
import { useAssessmentTabs } from "../../providers/AssessmentTabsProvider";
import { useTheme } from "@mui/material";
const useStyles = () => {
  const theme = useTheme();
  return getAssessmentTabsIndicatorStyle(theme);
};

const steps = ["Body Areas", "Global Judgments", "Dental Status"];

function AssessmentTabsIndicator() {
  let { selectedTab } = useAssessmentTabs();
  const styles = useStyles();
  return (
    <div style={{ ...styles.assessmentTabsIndicator }}>
      <Stepper activeStep={selectedTab} alternativeLabel>
        {steps.map((label, index) => (
          <Step
            key={label}
            sx={{
              "& .MuiStepLabel-root": {},
              "& .MuiStepLabel-root .Mui-completed": {
                color: "#0D47A1", // circle color (COMPLETED)
              },
              "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                {
                  color: "#09306D", // Just text label (COMPLETED)
                },
              "& .MuiStepLabel-root .Mui-active": {
                color: "#0D47A1", // circle color (ACTIVE)
              },
              "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel":
                {
                  color: "#09306D", // Just text label (ACTIVE)
                  fontWeight: "bold",
                },
              "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                fill: "white", // circle's number (ACTIVE)
              },
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

function AssessmentTabsIndicatorMobile() {
  let { selectedTab } = useAssessmentTabs();
  const styles = useStyles();

  return (
    <div style={{ ...styles.assessmentTabsIndicatorMobile }}>
      <Stepper activeStep={selectedTab}>
        {steps.map((label, index) => {
          return (
            <Step
              key={label}
              sx={{
                "& .MuiStepLabel-root .Mui-completed": {
                  color: "#0D47A1", // circle color (COMPLETED)
                },
                "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                  {
                    color: "#09306D", // Just text label (COMPLETED)
                  },
                "& .MuiStepLabel-root .Mui-active": {
                  color: "#0D47A1", // circle color (ACTIVE)
                },
                "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel":
                  {
                    color: "#09306D", // Just text label (ACTIVE)
                    fontWeight: "bold",
                  },
                "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                  fill: "white", // circle's number (ACTIVE)
                },
              }}
            >
              <StepLabel>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}

export { AssessmentTabsIndicator, AssessmentTabsIndicatorMobile };
